import { addMethod, string, StringSchema, TestOptionsMessage } from "yup"

addMethod(string, "requiredExcludeEmpty", function (this: StringSchema, message?: TestOptionsMessage) {
    return this.trim().required(message)
})
